/* eslint-disable react-hooks/exhaustive-deps */
import OrderType from './OrderType';
import { Button, Form } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { confirmDialog, Text, warningDialog, useText } from '@src/components';
import '@src/styles/cardOrder/cardInformation.scss';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadBalancesDelete,
  setTemplateStep,
  setOrderStep,
  setRunTimeTotalPrice,
  putLoadBalanceSubType,
  setSelectedRowKeys,
  setIsAllSelectedRowKeys,
  setExcelNoError,
  loadBalancesUpdate,
  setActiveStep,
  resetCurrentLoadBalance,
} from '@src/store/slice/balanceUploadSlice';
import {
  setBalanceUploadClear,
  resetBalanceFilterItems,
} from '@src/store/slice/balanceUploadDetailSlice';
import { useHistory } from 'react-router-dom';
import { getAppSettings, setLoadingState } from '@src/store/slice/appSettingsSlice';
import { getMaximumLoadedAmount } from '@src/store/slice/orderLimitsSlice';
import { Wait, moneyFormat } from '@src/utils/utils';
import CardListInformation from './CardListInformation';
import AdditionalInformation from './AdditionalInformation';
import CustomCollapseCard from '@src/components/CustomCollapseCard';
import { CustomImage } from '@src/components/index';
import ExcelUpload from '@src/pages/ticketRestaurant/balanceUpload/balanceInformation/ExcelUpload';
import iconBack from '@src/assets/icons/icon-back.svg';
import { VouIdCode } from '@src/store/enums';

const BalanceInformation = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const {
    currentLoadBalance,
    selectedRowKeys,
    activeStep,
    excelLoadBalanceList,
    runTimeTotalPrice,
  } = useSelector((state) => state?.balanceUpload);
  const { balanceUploadDetails, selectedBalanceUploadDetails } = useSelector(
    (state) => state?.balanceUploadDetail,
  );
  const dispatch = useDispatch();
  const [isExit, setIsExit] = useState(false);
  const [firstToSecondStep, setFirstToSecondStep] = useState(false);
  const [step2Array, setStep2Array] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedAndAmountedRows, setSelectedAndAmountedRows] = useState(0);

  const paginationBuilding = {
    currentPage: 1,
    pageSize: 1,
  };
  const orderContinueInstruction = useText('order.continueInstruction');
  const orderEnterBalanceForAtLeastOneCard = useText('order.enterBalanceForAtLeastOneCard');
  const name = useText('nameUpperCase');
  const surname = useText('surnameUpperCase');
  const referenceCode = useText('referenceCode3');
  const cardNumber = useText('cardNumber4');
  const totalPriceText = useText('totalPrice');
  const modalBakiyeOnayi = (message) => {
    warningDialog({
      title: <Text t="balanceApproval" />,
      message: message,
    });
  };
  useEffect(async () => {
    await dispatch(getAppSettings({ code: 'MaxDailyUpload' }));
    await dispatch(getAppSettings({ code: 'MaxDailyAmountWithoutTax' }));
    await dispatch(getMaximumLoadedAmount({ vouId: VouIdCode.Compliments }));
  }, [dispatch]);

  useEffect(async () => {
    try {
      let arr = [];
      selectedRowKeys?.map((rowKey) => {
        const findItem = balanceUploadDetails?.filter(
          (item) => item.cardNumber === rowKey.split('-')[2],
        );
        if (findItem) {
          arr.push(findItem[0]);
        }
      });
      setStep2Array(arr);
    } catch (error) {
      console.error(error);
    }
  }, [firstToSecondStep]);

  const clickOrderApproval = useCallback(async () => {
    setLoadingState(true);
    if (runTimeTotalPrice === 0) {
      modalBakiyeOnayi('Lütfen en az bir kart seçiniz.');
      return;
    }
    if (!firstToSecondStep && runTimeTotalPrice > 0) {
      setFirstToSecondStep(true);
      return;
    }
    await Wait(2200);
    const additionalInformationValues = await form.validateFields();
    if (additionalInformationValues.activationDate === null && runTimeTotalPrice === 0) {
      modalBakiyeOnayi(orderContinueInstruction);
      return Promise.resolve();
    }
    if (runTimeTotalPrice === 0) {
      modalBakiyeOnayi(orderEnterBalanceForAtLeastOneCard);
      return;
    }
    const body = {
      ...currentLoadBalance,
      ...additionalInformationValues,
      activationDate: additionalInformationValues.activationDate,
      orderStatus: 10,
      vouId: VouIdCode.Compliments,
    };
    await dispatch(loadBalancesUpdate(body));
    setLoadingState(false);
    await dispatch(setRunTimeTotalPrice(0));
    const orderBody = {
      orderSubType: excelLoadBalanceList.orderStep ? excelLoadBalanceList.orderStep : 2,
      excelTemplateType:
        excelLoadBalanceList.orderStep === 3 ? excelLoadBalanceList.templateStep : null,
      orderId: currentLoadBalance?.id,
    };
    await dispatch(putLoadBalanceSubType(orderBody));
    if (firstToSecondStep) await dispatch(setActiveStep(1));
  }, [currentLoadBalance, form, dispatch, runTimeTotalPrice, firstToSecondStep, selectedRowKeys]);

  const totalPrice = useMemo(() => {
    return balanceUploadDetails?.reduce((prc, item) => {
      return prc + item?.price;
    }, 0);
  }, [balanceUploadDetails]);

  const totalCardCount = useMemo(() => {
    return balanceUploadDetails?.filter((item) => item?.price > 0).length;
  }, [balanceUploadDetails]);

  useEffect(async () => {
    try {
      let count = 0;
      selectedRowKeys?.map((item) => {
        try {
          if (
            currentLoadBalance?.orderProcessType === 3 &&
            (balanceUploadDetails?.filter(
              (bItem) => bItem.id === parseInt(item.split('balance-upload-')[1], 10) - 1,
            )[0]?.price > 0 ||
              selectedBalanceUploadDetails?.filter(
                (bItem) => bItem.id === parseInt(item.split('balance-upload-')[1], 10) - 1,
              )[0]?.price > 0)
          ) {
            count += 1;
          } else if (
            balanceUploadDetails?.filter(
              (bItem) => bItem.cardNumber === item.split('balance-upload-')[1],
            )[0]?.price > 0
          ) {
            count += 1;
          }
        } catch (errorx) {
          console.error(errorx);
        }
      });
      setSelectedAndAmountedRows(count);
    } catch (error) {
      console.error(error);
    }
  }, [selectedRowKeys, totalPrice]);

  const clickOrderCancel = useCallback(async () => {
    await dispatch(loadBalancesDelete());
    setFirstToSecondStep(false);
  }, [dispatch, loadBalancesDelete]);

  const warningHtmlContent = <Text t="whenYouLeaveThisPageTheInformationYou" />;
  const giveUpText = useText('giveUp');

  useEffect(() => {
    const historyBlock = history.block((location) => {
      if (isExit) {
        return true;
      }
      if (
        activeStep === 0 &&
        runTimeTotalPrice > 0 &&
        currentLoadBalance.pendingApproval !== true
      ) {
        confirmDialog({
          title: <Text t="attention" />,
          htmlContent: warningHtmlContent,
          okText: <Text t="yes" />,
          cancelText: <Text t={giveUpText} />,
          closeIcon: false,
          onCancel: async (e) => {
            setIsExit(false);
            return false;
          },
          onOk: async () => {
            if (currentLoadBalance?.id > 0) {
              const body = { id: currentLoadBalance?.id };
              await dispatch(loadBalancesDelete(body));
              setFirstToSecondStep(false);
            }
            await dispatch(setOrderStep(null));
            setIsExit(true);
            await dispatch(resetCurrentLoadBalance());
            await dispatch(setRunTimeTotalPrice(0));
            history.push(location.pathname);
          },
        });
      } else {
        return true;
      }

      return false;
    });

    return historyBlock;
  }, [
    activeStep,
    runTimeTotalPrice,
    clickOrderCancel,
    history,
    isExit,
    dispatch,
    currentLoadBalance,
  ]);

  useEffect(async () => {
    const additionalInformationValues = await form.validateFields();
    if (
      additionalInformationValues.activationDate === null ||
      additionalInformationValues.activationDate === undefined
    ) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  }, [form]);

  const sendFormToParentPage = async () => {
    const additionalInformationValues = await form.getFieldsValue();
    if (
      additionalInformationValues.activationDate === null ||
      additionalInformationValues.activationDate === undefined
    ) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  const clickBalanceClear = useCallback(async () => {
    setTimeout(async () => {
      await dispatch(setBalanceUploadClear());
    }, 1250);
  }, [dispatch]);

  const isShowOrderArea = (currentLoadBalance) =>
    !(
      currentLoadBalance?.orderProcessType !== undefined &&
      currentLoadBalance?.orderProcessType !== 0
    );

  const step2Columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 70,
      render: (_, __, index) =>
        (paginationBuilding?.currentPage - 1) * paginationBuilding?.pageSize + index + 1,
    },
    {
      title: name,
      dataIndex: 'name',
      key: 'name',
      width: 162.7,
    },
    {
      title: surname,
      dataIndex: 'surname',
      key: 'surname',
      width: 162.7,
    },
    {
      title: referenceCode,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 150,
      align: 'center',
    },
    {
      title: cardNumber,
      dataIndex: 'cardNumber',
      key: 'cardNumber',
      width: 150,
      align: 'center',
    },
    {
      title: totalPriceText,
      dataIndex: 'price',
      key: 'price',
      width: 150,
      align: 'right',
      render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
    },
  ];

  return (
    <div className="compliment-balance-upload-content">
      {!firstToSecondStep && <OrderType />}

      {firstToSecondStep && (
        <CustomCollapseCard
          className={`order-type-card order-input-form-page`}
          bodyCenter
          cardTitle={<Text t="balanceDetailsToBeLoaded" />}
          cardTitleAlign="center"
          titleColor="#1d2228"
          titleSize="16px"
          showExpandIcon={false}
        >
          <div
            className="order-summary-col-3"
            style={{
              backgroundColor: '#fff',
              padding: 20,
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center',
              gap: 20,
            }}
          >
            <div
              className="custom-info-box"
              style={{
                width: 250,
                height: 90,
                paddingLeft: 30,
                justifyContent: 'center',
                display: 'flex',
                backgroundColor: '#f2f4f5',
                borderRadius: 8,
                flexDirection: 'column',
              }}
            >
              <div className="title">
                <span className="compliment-text1"><Text t="numberOfCards3" />:</span>
              </div>
              <span className="compliment-text4">{totalCardCount}</span>
            </div>
            <div
              className="custom-info-box"
              style={{
                width: 250,
                height: 90,
                paddingLeft: 30,
                justifyContent: 'center',
                display: 'flex',
                backgroundColor: '#f2f4f5',
                borderRadius: 8,
                flexDirection: 'column',
              }}
            >
              <div className="title">
                <span className="compliment-text1"><Text t="totalBalanceToBeLoaded" />:</span>
              </div>
              <span className="compliment-text4">{moneyFormat(totalPrice, true)}</span>
            </div>
          </div>
        </CustomCollapseCard>
      )}

      {firstToSecondStep && (
        <AdditionalInformation form={form} sendFormToParentPage={sendFormToParentPage} />
      )}
      {/*firstToSecondStep && (
        <CustomCollapseCard
          cardTitle={<Text t="userListToLoadBalance" />}
          className="comp-balance-upload-card-detail-information"
        >
          <div
            style={{
              padding: 8,
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              flexDirection: 'row',
            }}
            className="comp-balance-users-head-text2"
          >
            <span className="comp-balance-users-head-text1">{selectedRowKeys?.length}</span>{' '}
            Kullanıcı İçin Toplam Kredi Tutarı:{' '}
            <span className="comp-balance-users-head-text1">{moneyFormat(totalPrice, true)}</span>
          </div>

          <CustomTable
            pagination={false}
            dataSource={step2Array}
            columns={step2Columns}
            rowKey={(record) =>
              `comp-balance-upload-summary-detail-list-${record?.id || record?.name}`
            }
          />
        </CustomCollapseCard>
      )*/}
      {!firstToSecondStep && currentLoadBalance?.orderProcessType === 3 && (
        <ExcelUpload isCompliments={true} />
      )}
      {!firstToSecondStep &&
        currentLoadBalance.id !== 0 &&
        (currentLoadBalance?.orderProcessType !== 3 ||
          (currentLoadBalance?.orderProcessType === 3 && currentLoadBalance?.totalCount > 0)) && (
          <CardListInformation />
        )}
      {isShowOrderArea(currentLoadBalance) ? null : (
        <div
          id="custom-sticky-container"
          className={`custom-sticky-bar`}
          style={{ marginTop: 20, position: 'sticky', bottom: 0 }}
        >
          <div className="step-btn-container">
            {firstToSecondStep && (
              <Button
                className="comp-back-btn"
                onClick={async () => {
                  await dispatch(setSelectedRowKeys([]));
                  setFirstToSecondStep(false);
                  await dispatch(setIsAllSelectedRowKeys(false));
                  await clickOrderCancel();
                  await clickBalanceClear();
                }}
              >
                <CustomImage src={iconBack} />
                <Text t="turnBack" />
              </Button>
            )}
            {firstToSecondStep && <div style={{ display: 'flex', flex: 1 }} />}
            {!firstToSecondStep && (
              <Button
                id="comp-balanceUpload-balanceInformation-main-cancel-btn"
                className="cancel-btn"
                onClick={() => {
                  return confirmDialog({
                    title: <Text t="attention" />,
                    htmlContent: <Text t="areYouSureYouWantToCancelThe" />,
                    okText: <Text t="yes" />,
                    cancelText: <Text t="no" />,
                    onOk: async () => {
                      await dispatch(setOrderStep(null));
                      await dispatch(setTemplateStep(0));
                      await dispatch(setSelectedRowKeys([]));
                      await dispatch(setIsAllSelectedRowKeys(false));
                      await dispatch(resetBalanceFilterItems());
                      await dispatch(setRunTimeTotalPrice(0));
                      await dispatch(setExcelNoError(false));
                      await clickOrderCancel();
                      await clickBalanceClear();
                    },
                    onCancel: async () => {},
                  });
                }}
              >
                <Text t="giveUp" />
              </Button>
            )}
            <Button
              id="comp-balanceUpload-balanceInformation-main-next-btn"
              className="next-btn"
              disabled={
                firstToSecondStep
                  ? runTimeTotalPrice === 0 || buttonDisabled
                  : runTimeTotalPrice === 0
              }
              onClick={clickOrderApproval}
            >
              <Text t="continue" />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BalanceInformation;
